import React from 'react';

export default function KennelIcon({ size = 24, color = 'currentColor', className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Roof */}
      <path
        d="M3 11L12 4L21 11"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Walls */}
      <path
        d="M5 10V19C5 19.55 5.45 20 6 20H18C18.55 20 19 19.55 19 19V10"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Door arch */}
      <path
        d="M10 20V15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15V20"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
